import {
  CLEAR_NOTIFICATION,
  CLOSE_WEB_NOTIFICATION,
  EMIT_SOCKET_TYPING,
  GET_BROADCASTS_COUNT,
  GET_BROADCASTS_COUNT_ERROR,
  GET_BROADCASTS_COUNT_SUCCESS,
  GET_DOWNTIME_MESSAGE,
  GET_DOWNTIME_MESSAGE_SUCCESS,
  GET_LANGUAGES,
  GET_LANGUAGES_ERROR,
  GET_LANGUAGES_SUCCESS,
  HIDE_EXPIRING_PASSWORD_ALERT,
  IGNORE_WEB_NOTIFICATION,
  LOAD_INTAKE_FORMS_SQUIGGLIES,
  LOAD_INTAKE_FORMS_SQUIGGLIES_ERROR,
  LOAD_INTAKE_FORMS_SQUIGGLIES_SUCCESS,
  LOAD_MASTER_USER,
  LOAD_MASTER_USER_ERROR,
  LOAD_MASTER_USER_SUCCESS,
  LOAD_WIDGET_USER,
  LOAD_WIDGET_USER_ERROR,
  LOAD_WIDGET_USER_SUCCESS,
  ON_SOCKET_ACTIVITY,
  ON_SOCKET_AVAILABILITY,
  ON_SOCKET_BROADCAST_UPDATE,
  ON_SOCKET_UPLOAD_UPDATE,
  ON_SOCKET_USER_UPDATE,
  ON_SOCKET_CHAT_ACTIVITY,
  ON_SOCKET_HAS_NEW_ACTIVITY,
  ON_SOCKET_MESSAGE,
  ON_SOCKET_OFFER,
  ON_SOCKET_REFERRAL_PENDING,
  ON_SOCKET_TELEHEALTH_STATUS_UPDATE,
  ON_SOCKET_TELEHEALTH,
  ON_SOCKET_UPLOAD_APPOINTMENT_UPDATE,
  ON_SOCKET_UPLOAD_PATIENT_UPDATE,
  ON_SOCKET_UPLOAD_RECALL_UPDATE,
  ON_SOCKET_UPLOAD_REFERRAL_UPDATE,
  ON_SOCKET_WAITING_ROOM_PATIENT_CREATE,
  ON_SOCKET_WAITING_ROOM_PATIENT_STATUS_UPDATE,
  ON_SOCKET_WAITING_ROOM_PATIENT_UPDATE,
  REGISTER_SOCKET,
  RESFRESH_CURRENT_USER,
  SET_ACHIEVEMENT_TYPE,
  SHOW_EXPIRING_PASSWORD_ALERT,
  SHOW_WEB_NOTIFICATION,
  WEB_NOTIFICATION_SHOWED,
  ON_SOCKET_PRESENCE_USER_ONLINE,
  ON_SOCKET_PRESENCE_USER_OFFLINE,
  LOAD_PATIENT_JOURNEY,
  LOAD_PATIENT_JOURNEY_SUCCESS,
  LOAD_PATIENT_JOURNEY_ERROR,
} from './constants';

export const clearNotification = () => ({ type: CLEAR_NOTIFICATION });

export const closeWebNotification = () => ({ type: CLOSE_WEB_NOTIFICATION });

export const emitTyping = (payload) => ({
  type: EMIT_SOCKET_TYPING,
  payload,
});

export const getBroadcastsCount = () => ({
  type: GET_BROADCASTS_COUNT,
});

export const getBroadcastsCountError = (error) => ({
  type: GET_BROADCASTS_COUNT_ERROR,
  error,
});

export const getBroadcastsCountSuccess = (response) => ({
  type: GET_BROADCASTS_COUNT_SUCCESS,
  response,
});

export const getDowntimeMessage = () => ({ type: GET_DOWNTIME_MESSAGE });

export const getDowntimeMessageSuccess = (downtimeMessage) => ({
  type: GET_DOWNTIME_MESSAGE_SUCCESS,
  downtimeMessage,
});

export const getLanguages = () => ({
  type: GET_LANGUAGES,
});

export const getLanguagesError = (error) => ({
  type: GET_LANGUAGES_ERROR,
  error,
});

export const getLanguagesSuccess = (response) => ({
  type: GET_LANGUAGES_SUCCESS,
  response,
});

export const hideExpiringPasswordAlert = () => ({ type: HIDE_EXPIRING_PASSWORD_ALERT });

export const ignoreWebNotification = () => ({ type: IGNORE_WEB_NOTIFICATION });

export const loadIntakeFormsSquigglies = () => ({
  type: LOAD_INTAKE_FORMS_SQUIGGLIES,
});

export const loadIntakeFormsSquiggliesError = (error) => ({
  type: LOAD_INTAKE_FORMS_SQUIGGLIES_ERROR,
  error,
});

export const loadIntakeFormsSquiggliesSuccess = (intakeFormsSquigglies) => ({
  type: LOAD_INTAKE_FORMS_SQUIGGLIES_SUCCESS,
  intakeFormsSquigglies,
});

export const loadMasterUser = () => ({
  type: LOAD_MASTER_USER,
});

export const loadMasterUserError = (error) => ({
  type: LOAD_MASTER_USER_ERROR,
  error,
});

export const loadMasterUserSuccess = (user) => ({
  type: LOAD_MASTER_USER_SUCCESS,
  user,
});

export const loadWidgetUser = () => ({
  type: LOAD_WIDGET_USER,
  loading: false,
});

export const loadWidgetUserSuccess = (response) => ({
  type: LOAD_WIDGET_USER_SUCCESS,
  response,
});

export const loadWidgetUserError = (error) => ({
  type: LOAD_WIDGET_USER_ERROR,
  error,
});

export const onSocketActivity = (data) => ({
  type: ON_SOCKET_ACTIVITY,
  data,
});

export const onSocketAvailability = (data) => ({
  type: ON_SOCKET_AVAILABILITY,
  data,
});

export const onSocketHasNewActivity = () => ({ type: ON_SOCKET_HAS_NEW_ACTIVITY });

export const onSocketBroadcastUpdate = (broadcast) => ({
  type: ON_SOCKET_BROADCAST_UPDATE,
  broadcast,
});

export const onSocketUploadUpdate = (upload) => ({
  type: ON_SOCKET_UPLOAD_UPDATE,
  upload,
});

export const onSocketUserUpdate = (data) => ({
  type: ON_SOCKET_USER_UPDATE,
  data,
});

export const onSocketMessage = (message) => ({
  type: ON_SOCKET_MESSAGE,
  message,
});

export const onSocketOffer = (data) => ({
  type: ON_SOCKET_OFFER,
  data,
});

export const onSocketReferralPending = (data) => ({
  type: ON_SOCKET_REFERRAL_PENDING,
  data,
});

export const onSocketChatActivity = (data) => ({
  type: ON_SOCKET_CHAT_ACTIVITY,
  data,
});

export const onSocketTelehealthStatusUpdate = (data) => ({
  type: ON_SOCKET_TELEHEALTH_STATUS_UPDATE,
  data,
});

export const onSocketTelehealth = (data) => ({
  type: ON_SOCKET_TELEHEALTH,
  data,
});

export const onSocketUploadPatientUpdate = (data) => ({
  type: ON_SOCKET_UPLOAD_PATIENT_UPDATE,
  data,
});

export const onSocketUploadReferralUpdate = (data) => ({
  type: ON_SOCKET_UPLOAD_REFERRAL_UPDATE,
  data,
});

export const onSocketUploadRecallUpdate = (data) => ({
  type: ON_SOCKET_UPLOAD_RECALL_UPDATE,
  data,
});

export const onSocketUploadAppointmentUpdate = (data) => ({
  type: ON_SOCKET_UPLOAD_APPOINTMENT_UPDATE,
  data,
});

export const onSocketWaitingRoomPatientStatusUpdate = (data) => ({
  type: ON_SOCKET_WAITING_ROOM_PATIENT_STATUS_UPDATE,
  data,
});

export const onSocketWaitingRoomPatientCreate = (data) => ({
  type: ON_SOCKET_WAITING_ROOM_PATIENT_CREATE,
  data,
});

export const onSocketWaitingRoomPatientUpdate = (data) => ({
  type: ON_SOCKET_WAITING_ROOM_PATIENT_UPDATE,
  data,
});

export const refreshCurrentUser = (user) => ({
  type: RESFRESH_CURRENT_USER,
  user,
});

export const registerSocket = (user) => ({
  type: REGISTER_SOCKET,
  user,
});

export const setAchievementType = (achievementType) => ({
  type: SET_ACHIEVEMENT_TYPE,
  achievementType,
});

export const showExpiringPasswordAlert = () => ({ type: SHOW_EXPIRING_PASSWORD_ALERT });

export const showWebNotification = (data, notificationType) => ({
  type: SHOW_WEB_NOTIFICATION,
  data,
  notificationType,
});

export const webNotificationShowed = (data) => ({
  type: WEB_NOTIFICATION_SHOWED,
  data,
});

export const onSocketSetOnlineUser = (data) => ({
  type: ON_SOCKET_PRESENCE_USER_ONLINE,
  data,
});

export const onSocketSetOfflineUser = (data) => ({
  type: ON_SOCKET_PRESENCE_USER_OFFLINE,
  data,
});

export const loadPatientJourney = (id, rangeBy, includeDetails) => ({
  type: LOAD_PATIENT_JOURNEY,
  loading: true,
  id,
  rangeBy,
  includeDetails,
});

export const loadPatientJourneyError = (error) => ({
  type: LOAD_PATIENT_JOURNEY_ERROR,
  error,
});

export const loadPatientJourneySuccess = (response) => ({
  type: LOAD_PATIENT_JOURNEY_SUCCESS,
  response,
});
